export default class SupplierNotificationMessage {
    constructor(item = {}) {
        this.subject = item.subject || "";
        this.content = item.content || "";
    }
}
